import axios from 'axios';

const api = axios.create({ baseURL: '/api', timeout: 15000 });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('hms_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      let role = '';
      try { role = JSON.parse(localStorage.getItem('hms_session'))?.role || ''; } catch {}
      localStorage.removeItem('hms_token');
      localStorage.removeItem('hms_user');
      localStorage.removeItem('hms_session');
      const adminArea = role === 'admin' || window.location.pathname.startsWith('/admin');
      const target = adminArea ? '/admin/login' : '/login';
      if (window.location.pathname !== target) window.location.href = target;
    }
    return Promise.reject(err);
  }
);

export default api;
